"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkAlreadyRendered;

var _defs = _interopRequireDefault(require("../../_core/defs"));

var _seempleerror = _interopRequireDefault(require("../../_helpers/seempleerror"));

// checks is item already rendered in an array
// selfDef is given instead of itself (array) for perf optimisation
function checkAlreadyRendered(_ref) {
  var item = _ref.item,
      selfDef = _ref.selfDef;

  var itemDef = _defs["default"].get(item);

  var selfId = selfDef.id; // if item object is defined in object defs

  if (itemDef) {
    var renderedInArrays = itemDef.renderedInArrays; // if item's node is already rendered for an array
    // then throw an error

    if (renderedInArrays && renderedInArrays[selfId]) {
      throw (0, _seempleerror["default"])('array:add_render_twice');
    }
  }
}
//# sourceMappingURL=checkalreadyrendered.js.map